(function(){
    let shop_this_project_widget = document.querySelector('.shop-project'),
        mobileView = window.matchMedia('(max-width: 992px)'),
        first_el;

    const elementsInit = () => {
        first_el = document.querySelector('.article-main-sidebar > div:nth-child(1)');
        //shop_this_project_widget = document.querySelector('.shop-project');
        ref_social_share = document.querySelector('.social-share-wrapper');
    }

    const showMobileElements = () => {
        ref_social_share.insertAdjacentElement('beforebegin', shop_this_project_widget); 
    }

    const showDesktopElements = () => {
        first_el.insertAdjacentElement('afterbegin', shop_this_project_widget);
    }

    const mediaQueriesState = (e) => {
        if (e.matches) {
            showMobileElements();
        } else {
            showDesktopElements();
        }
    }

    window.addEventListener('load', () => {
        // If there is no widget - do nothing.
        if (!shop_this_project_widget) return;

        elementsInit();
        mediaQueriesState(mobileView);
        mobileView.addListener(mediaQueriesState);
    });

})();